import { TherapistClassificationInfoResponseModel } from './classificationinfo-response-model';
export class TherapistClassificationInfoModel {
  appUserInfoId: string;
  modifiedByUserInfoId: number;
  TherapistClassification: TherapistClassificationInfoResponseModel[];
}
